import { render } from "./DickOne.vue?vue&type=template&id=b0d76e9a"
import script from "./DickOne.vue?vue&type=script&lang=js"
export * from "./DickOne.vue?vue&type=script&lang=js"

import "./DickOne.vue?vue&type=style&index=0&id=b0d76e9a&lang=css"
script.render = render

export default script